package com.nonopn.skywatcher.maps

data class XY(
    val x: Double,
    val y: Double
) {
    fun toPair() = x to y
}
